<template>
  <div class="no-data-box">
    <div class="no-data-content">
      <img draggable="false" :src="noData" alt="" />
      <span class="no-data-text">{{ translateTitle(text) }}</span>
    </div>
  </div>
</template>
<script>
import commonMixin from "@/components/common/commonMixin.vue";
import { VUE_APP_ID, VUE_UNION_STATION } from "@/assets/js/stationSetting";

export default {
  mixins: [commonMixin],
  props: {
    text: {
      type: String,
      default: "暂无数据",
    },
  },
  data() {
    return {
      noData: "",
    };
  },
  created() {
    if (VUE_APP_ID == "9wZvazddcsWrnWtnB7Zhy399") {
      this.noData = require("../../assets/img/home/bijiu-no-data.png");
    } else if (VUE_UNION_STATION == "EverTrust") {
      this.noData = require("../../assets/img/home/bijiu-no-data.png");
    } else if (VUE_UNION_STATION == "MaskEx") {
      this.noData = require("../../assets/img/home/mask-no-data.png");
    } else if (VUE_UNION_STATION == "100Ex") {
      this.noData = require("../../assets/img/home/no-data-100.png");
    } else if (VUE_UNION_STATION == "8V") {
      this.noData = require("../../assets/img/home/no-data-8v.png");
    } else if (VUE_UNION_STATION == "UEEx") {
      this.noData = require("../../assets/img/home/no-data-UEEx.png");
    } else if (VUE_UNION_STATION == "Ahex") {
      this.noData = require("../../assets/img/home/no-data-Ahex.png");
    } else if (VUE_UNION_STATION == "5A") {
      this.noData = require("../../assets/img/home/no-data-5A.png");
    } else if (VUE_UNION_STATION == "bitda") {
      this.noData = require("../../assets/img/home/no-data-bitda.png");
    } else if (VUE_UNION_STATION == "S6") {
      this.noData = require("../../assets/img/home/no-data-S6.png");
    } else if (VUE_UNION_STATION == "easy") {
      this.noData = require("../../assets/img/home/no-data-easy.png");
    } else if (VUE_UNION_STATION == "spex") {
      this.noData = require("../../assets/img/home/no-data-spex.png");
    } else if (VUE_UNION_STATION == "8coin") {
      this.noData = require("../../assets/img/home/no-data-8coin.png");
    } else {
      this.noData = require("../../assets/img/home/no_data.png");
    }
  },
};
</script>
<style lang="scss">
.no-data-box {
  // height: 100%;
  // width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  min-height: 200px;
  // max-width: 976px;
  text-align: center;
  background: #fff;
  user-select: none;
  .no-data-content {
    user-select: none;
    width: 100%;
    img {
      display: flex;
      margin: 0 auto;
      width: 80px;
    }
    .no-data-text {
      color: #909399;
      line-height: 1;
      font-size: 14px;
      margin-top: 15px;
      display: block;
    }
  }
}
</style>
